import { SignatureRow } from 'components/tables/data/signature/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the technician name.
 */
export default function TechnicianNameColumn({ data: { technician } }: { data: SignatureRow }) {
  if (!technician?.fullName) {
    return null;
  }

  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {technician.fullName}
    </P2Regular>
  );
}
